import { configureStore } from '@reduxjs/toolkit';
import pageSliceReducer from '../redux/settings/page-settings-slice';
import { apiSlice } from '../redux/api-slice';
import { categoryApiSlice } from '../redux/api-category-slice';
import filterStateReducer from '../redux/filter/filter-slice';

export const store = configureStore({
    reducer: {
        filterState: filterStateReducer,
        pageSettings: pageSliceReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
        [categoryApiSlice.reducerPath]: categoryApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(apiSlice.middleware)
        .concat(categoryApiSlice.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
